module.exports = __webpack_public_path__ + "fonts/EurostileBold.ed2308a.woff2";